export function formatHourMask(input) {
  let raw = (input || '').replace(/\D/g, '').slice(0, 6);

  if (raw.length <= 2) {
    return raw;
  } else if (raw.length <= 4) {
    return `${raw.slice(0, 2)}:${raw.slice(2)}`;
  } else {
    return `${raw.slice(0, 2)}:${raw.slice(2, 4)}:${raw.slice(4)}`;
  }
}